// extracted by mini-css-extract-plugin
export default {"TasksFilters":"TaskFilters_TasksFilters__QFTfy"};